import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { GtmService } from '@core/services/gtm.service';
import { GTM_IDS } from '@features/all-stars/models/gts.model';
import { Locale, PublicLocaleService } from '../../../public/questionnaire/services/public-locale.service';

export const GTM_BY_DOMAIN: Record<string, string | null> = {
  'app.lgleadplatform.nl': GTM_IDS.nlPlatform,
  'app.lgleadplatform.be': GTM_IDS.bePlatform,
  'warmtepomp-offerte.lgsolutions.nl': GTM_IDS.nlPlatform,
  'airco-offerte.lgsolutions.nl': GTM_IDS.nlPlatform,
  'app.plataformadeleadslg.es': GTM_IDS.esPlatform,
  'app.lgleadplatform.gr': GTM_IDS.grPlatform,
  'hs.lg.emendis.nl': GTM_IDS.nlHs,
  'lg-electronics.acceptatie.emendis.nl': GTM_IDS.nlPlatform,
  'lg-electronics-nl.acceptatie.emendis.nl': GTM_IDS.nlPlatform,
  'lg-electronics-el.acceptatie.emendis.nl': GTM_IDS.grPlatform,
  'lg-electronics-es.acceptatie.emendis.nl': GTM_IDS.esPlatform,
  'lg-electronics-en.acceptatie.emendis.nl': GTM_IDS.nlPlatform,
  'lg-electronics-de.acceptatie.emendis.nl': GTM_IDS.dePlatform,
};

export const GTM_BY_LANG: Record<string, string | null> = {
  nl: GTM_IDS.nlPlatform,
  be: GTM_IDS.bePlatform,
  el: GTM_IDS.grPlatform,
  gr: GTM_IDS.grPlatform,
  es: GTM_IDS.esPlatform,
  de: GTM_IDS.dePlatform,
  en: GTM_IDS.nlPlatform,
};

export const gtmInitResolver: ResolveFn<boolean> = () => {
  const gtmService = inject(GtmService);
  const translate = inject(PublicLocaleService);

  const hostname = window.location.hostname;

  let gtmId = GTM_BY_DOMAIN[hostname] || null;

  if (hostname === 'hvac-quotation.lg.com') {
    const lang = translate.locale || Locale.NL;

    gtmId = GTM_BY_LANG[lang] || null;
  }

  if (gtmId) {
    gtmService.init(gtmId);
  }

  return true;
};
